import amplitude from 'utils/amplitude';
import { IProduct } from 'Modules/Products/types';
import { EnumEvents, EnumFromName } from 'constants/enums';
import { convertDashToSpace } from './utils';
import { ISomeOrder } from './types';

function formatForAmplitude(product: IProduct, order: ISomeOrder, from: EnumFromName, from_product_page: boolean) {
  const { model_id, name } = product;
  const { id: order_id } = order;

  return convertDashToSpace({
    model_id,
    name,
    order_id,
    from,
    from_product_page,
  });
}

export default function likeProductAnalitic(
  product: IProduct,
  order: ISomeOrder,
  from: EnumFromName,
  from_product_page: boolean
) {
  amplitude.logEvent(EnumEvents.SHOPPING_LIKE_PRODUCT, formatForAmplitude(product, order, from, from_product_page));
}
